import React from 'react';
import { Flex, Spinner } from '@zillow/constellation';

const SpinnerContainer: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = () => {
  return (
    <Flex display="flex" alignItems="center" justifyContent="center" flex="1">
      <Spinner size="lg" style={{ height: '100vh' }} />
    </Flex>
  );
};

export default SpinnerContainer;
